export interface IContactInfo {
  label: string;
  value: string;
  type: 'email' | 'phone' | 'other'
}
export const ContactInformation: IContactInfo[] = [
  {
    label: 'Email',
    value: 'cs_life@singlife.com',
    type: 'email'
  },
  {
    label: 'Call',
    value: '+65 6827 9933',
    type: 'phone'
  },
  {
    label: 'Mondays to Fridays:',
    value: '8.45am to 5.30pm',
    type: 'other'
  },
  {
    label: 'Saturdays, Sundays & Public Holidays: ',
    value: 'Closed',
    type: 'other'
  }
];